const ServicesAppData = [
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Custom Mobile App Development",
    paragraph:
      "Every business is different, so your app should be too. We create apps tailored to your goals – whether it's iOS, Android, or both. The result? A product that feels made just for you and your users.",
  },
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "UI/UX Design",
    paragraph:
      "First impressions matter. That's why we design apps that not only look good but also feel effortless to use. Smooth, intuitive, and enjoyable - because happy users always come back.",
  },
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "Cross-Platform Development",
    paragraph:
      "Why build two apps when one can do the job? Our cross-platform solutions save you time and money, while still giving your users the seamless experience they expect.",
  },
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "App Testing & Quality Assurance",
    paragraph:
      "Nobody likes glitches. We carefully test your app to make sure it's fast, reliable, and ready for the real world before it ever reaches your customers.",
  },
  {
    icon: "/assets/cloud/image1.svg",
    iconStyles: "w-[92.22px] h-[87px]",
    heading: "App Maintenance & Support",
    paragraph:
      "Launching your app is just the start. We stick around to keep it updated, secure, and performing at its best as your business grows.",
  },
];

 const points = [
   { content1: "Apps that perform well and scale easily" },
   { content1: "Designs people love to use" },
   { content1: "Security and reliability you can count on" },
   { content1: "A partner who supports you before and after launch" },
 ];

export { ServicesAppData, points };